import {Link} from '@aboutyou/router';
import {styled} from '@linaria/react';

export const UnstyledLinkLinaria = styled(Link)`
  &,
  &:hover,
  &:visited {
    text-decoration: none;
    color: inherit;
  }
`;
